import * as React from 'react';

interface DomElementProps {
    element: Element;
}

export const DomElement = function ({ element }: DomElementProps) {
    return <div ref={(p) => p && p.replaceWith(element)} />;
};
